import apiFetch from '../apiFetch'

export default function (idGrupoVerraco, token) {
  return apiFetch({endPoint: `GrupoVerraco/getGrupoVerracoCambioEstado`, method: 'POST', body: {idGrupoVerraco}, token: token})
}
